import { Box, Center, Circle, Icon, VStack, Text } from '@chakra-ui/react';
import { COLORS } from '../../constant';
import { Caption } from '../../shared/Typography';

const WebhooksEmptyHistoryIcon = ({
  backgroundColor = COLORS.GRAY.GRAY_200,
}: {
  backgroundColor?: string;
}) => (
  <Circle size="64px" bg={backgroundColor}>
    <Center>
      <Icon viewBox="0 0 48 48" boxSize="12" color="red.500">
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M30.6 32.1808L22.8654 24.4462V14.8654H25.1346V23.5539L32.1807 30.6L30.6 32.1808ZM6.90775 32.4577C6.35648 31.3115 5.92443 30.1224 5.6116 28.8904C5.2988 27.6583 5.10522 26.4064 5.03085 25.1346H7.2808C7.34747 26.2038 7.52695 27.2583 7.81925 28.2981C8.11155 29.3378 8.4795 30.3462 8.9231 31.3231L6.90775 32.4577ZM5.03085 22.8654C5.10522 21.5731 5.302 20.3109 5.6212 19.0789C5.94043 17.8468 6.38595 16.6513 6.95775 15.4923L8.9231 16.6269C8.44617 17.6038 8.06988 18.6205 7.79425 19.677C7.51862 20.7334 7.34747 21.7962 7.2808 22.8654H5.03085ZM13.527 39.9384C12.4219 39.2051 11.4014 38.382 10.4654 37.4692C9.52955 36.5564 8.7116 35.5474 8.0116 34.4423L10.0077 33.2885C10.6 34.2115 11.293 35.0699 12.0866 35.8635C12.8802 36.6571 13.7385 37.35 14.6615 37.9423L13.527 39.9384ZM10.0077 14.6616L8.04235 13.527C8.74235 12.4347 9.55838 11.4257 10.4904 10.5001C11.4225 9.57442 12.4347 8.7616 13.527 8.0616L14.6615 10.0385C13.7385 10.6436 12.8833 11.3346 12.0961 12.1116C11.309 12.8885 10.6128 13.7385 10.0077 14.6616ZM22.8654 42.9692C21.5731 42.8948 20.3109 42.698 19.0788 42.3788C17.8468 42.0596 16.6513 41.6141 15.4923 41.0423L16.6269 39.0769C17.6038 39.5538 18.6205 39.9301 19.6769 40.2058C20.7333 40.4814 21.7962 40.6525 22.8654 40.7192V42.9692ZM16.6269 8.9039L15.4923 6.95775C16.6513 6.38595 17.8468 5.94044 19.0788 5.6212C20.3109 5.302 21.5731 5.10522 22.8654 5.03085V7.2808C21.7962 7.34747 20.7333 7.51862 19.6769 7.79425C18.6205 8.06989 17.6038 8.43977 16.6269 8.9039ZM25.1346 42.9692V40.7192C26.2038 40.6525 27.2666 40.4814 28.323 40.2058C29.3795 39.9301 30.3962 39.5538 31.3731 39.0769L32.5077 41.0423C31.3487 41.6141 30.1532 42.0596 28.9211 42.3788C27.6891 42.698 26.4269 42.8948 25.1346 42.9692ZM31.3731 8.9039C30.3962 8.43977 29.3795 8.06989 28.323 7.79425C27.2666 7.51862 26.2038 7.34747 25.1346 7.2808V5.03085C26.4269 5.10522 27.6891 5.29689 28.9211 5.60585C30.1532 5.91482 31.3487 6.36545 32.5077 6.95775L31.3731 8.9039ZM34.473 39.9384L33.3384 37.9423C34.2615 37.35 35.1115 36.6654 35.8884 35.8885C36.6654 35.1115 37.3564 34.2615 37.9616 33.3385L39.9384 34.473C39.2384 35.5653 38.4256 36.5711 37.5 37.4904C36.5743 38.4096 35.5653 39.2256 34.473 39.9384ZM37.9616 14.6424C37.3564 13.7193 36.6654 12.8725 35.8884 12.102C35.1115 11.3314 34.2615 10.6436 33.3384 10.0385L34.473 8.0616C35.5653 8.7744 36.566 9.58722 37.475 10.5001C38.3839 11.4129 39.1948 12.4155 39.9076 13.5078L37.9616 14.6424ZM40.7192 22.8654C40.6525 21.7628 40.473 20.6917 40.1807 19.652C39.8885 18.6122 39.5038 17.5974 39.0269 16.6077L41.0422 15.4731C41.6345 16.6321 42.0852 17.8276 42.3941 19.0597C42.7031 20.2917 42.8948 21.5603 42.9692 22.8654H40.7192ZM41.0422 32.5077L39.0961 31.3731C39.5602 30.3962 39.9301 29.3795 40.2057 28.3231C40.4814 27.2667 40.6525 26.2038 40.7192 25.1346H42.9692C42.8948 26.4269 42.698 27.6891 42.3788 28.9212C42.0596 30.1532 41.614 31.3487 41.0422 32.5077Z"
            fill="#3E4AE7"
          />
        </svg>
      </Icon>
    </Center>
  </Circle>
);

export const WebhookMessagesEmpty = () => {
  return (
    <>
      <Box>
        <Center height="265">
          <Caption>
            <VStack>
              <Center>
                <WebhooksEmptyHistoryIcon />
              </Center>
              <Box paddingTop="12px">
                <Text
                  fontWeight="600"
                  lineHeight="24px"
                  fontSize="16px"
                  fontStyle="normal"
                  align="center"
                >
                  {"There's nothing here just yet"}
                </Text>
                <Text
                  fontWeight="200"
                  lineHeight="24px"
                  fontSize="16px"
                  fontStyle="normal"
                >
                  Your webhook event history will eventually show up here
                </Text>
              </Box>
            </VStack>
          </Caption>
        </Center>
      </Box>
    </>
  );
};
